/* istanbul ignore file */
import { BrowserRouter as Router } from 'react-router-dom';
import { Theme } from 'react-daisyui';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import '@/css/App.css';
import usePendo from '@/hooks/usePendo';
import { UserProvider } from '@/context/UserContext';
import { FeatureFlagProvider } from '@/context/FeatureFlagContext';

import { Footer } from '@/components/Footer';
import Routes from './Router';

export default function App() {
  const pendo = usePendo();

  return (
    <UserProvider>
      <FeatureFlagProvider>
        <HelmetProvider>
          {pendo.isInstalled() && (
            <Helmet>
              <script>{pendo.script}</script>
            </Helmet>
          )}
          <Theme dataTheme='opstart'>
            <Router>
              <Routes />
              <Footer />
            </Router>
          </Theme>
        </HelmetProvider>
      </FeatureFlagProvider>
    </UserProvider>
  );
}
